// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3lnaD","actions":"Pagination_actions__2scDJ","wrapperActions":"Pagination_wrapperActions__3wS8h","goToPage":"Pagination_goToPage__6mxgD"};